var collapsible_list_component_rtlignore_default = {
  "ltr": "KB4Z5",
  "rtl": "nyiXf",
  "iconContainer": "nDVy3",
  "icon": "bBh3j",
  "isExpanded": "lR0cN",
  "listDimensions": "_1cuQ6"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
